import React from "react";

interface ICellDate {
  locales?: string | string[];
  date: string | Date;
}

const CellDate: React.FC<ICellDate> = (props) => {
  const { locales, date } = props;

  return (
    <p className="text-sm font-bold text-navy-700 dark:text-white">
      {new Date(
        typeof date === "string" ? date : (date as unknown as string)
      ).toLocaleDateString(locales ?? "id-ID", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      })}
    </p>
  );
};

export default CellDate;
